var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"100vw"},attrs:{"src":require("../assets/img/banner_3.jpg")}}),_c('Breadcrumb'),_c('ComTitle'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }